// Package imports:
import React from 'react';
import cx from 'classnames'

interface IProps {
	columns: Array<string>,
	rows: any,
	className?: string,
}

const BaseTable: React.FC<IProps> = ({ 
  columns, 
  rows,
  className,
  ...props
 }) => {
  return (
    <div className={cx('KCL_base-table', className)} {...props}>
		<table>
			<thead>
				<tr>
				{columns.map((th: string, index: any) => (
					<th key={index}>
						<span>{th}</span>
					</th>
				))}
				</tr>
			</thead>

			<tbody>
				{rows && rows.map((data: any, index: any) => (
					<tr key={index}>
						{data.map((td: any, ind: any) => (
						<td key={`td${ind}`}>
							<div className="flex items-center">

								{typeof td.label === 'string' ? (
									<span dangerouslySetInnerHTML={{__html: td.label}}></span>
								) : (
									<span>{ td.label }</span>
								)}
							</div>
						</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
    </div>
  )
}

export default BaseTable
